module.exports = __webpack_public_path__ + "static/img/jewellery_home_earrings.6f6c032.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeImg/jewellery_home_earrings.png
// module id = UA3k
// module chunks = 0